import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import WindowedSelect, { createFilter } from "react-windowed-select";
import { constants, EndPoint, headers, messages } from "../../common/constants";
import {
  validateBorrowAndLoan,
  validateC_N,
  validateCpty,
  validateDiv,
  validateProfitCenter,
  validateQuantity,
  validateRate,
  validateTermDate,
  validateTicker,
  validateValue,
} from "../../common/tradeValidations";
import { ToastContainer, toast } from "react-toastify";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import { calculateContractPriceFromValues } from "../../common/commonFunctions";

const SingleEntry = (props: any): any => {
  const [checkedRadio, setCheckedRadio] = useState(props?.trade?.isMatchTrade);
  const [bl, setBL] = useState(props?.trade?.bl);
  const [bCpty, setBCpty] = useState(props?.trade?.bCpty);
  const [ticker, setTicker] = useState(props?.trade);
  const [tickerName, setTickerName] = useState(props?.trade?.name);
  const [tickerPrice, setTickerPrice] = useState(props?.trade?.price);
  const [borrow] = useState(props?.isMatchTrade ? props?.trade?.bl : "B");
  const [loan] = useState(props?.isMatchTrade ? props?.trade?.bl : "L");
  const [lCpty, setLCpty] = useState(props?.trade?.lCpty);
  const [quantity, setQuantity] = useState(props?.trade?.quantity);
  const [bRate, setBRate] = useState(props?.trade?.bRate);
  const [lRate, setLRate] = useState(props?.trade?.lRate);
  const [bMark, setBMark] = useState(props?.trade?.bMark);
  const [lMark, setLMark] = useState(props?.trade?.lMark);
  const [bValue, setBValue] = useState(props?.trade?.bValue);
  const [lValue, setLValue] = useState(props?.trade?.lValue);
  const [bCN, setBCN] = useState(props?.trade?.bCN);
  const [lCN, setLCN] = useState(props?.trade?.bCN);
  const [bDiv, setBDiv] = useState(props?.trade?.bDiv);
  const [lDiv, setLDiv] = useState(props?.trade?.lDiv);
  const [lPC, setLPC] = useState(props?.trade?.lPC);
  const [bPC, setBPC] = useState(props?.trade?.bPC);
  const [termDate, setTermDate] = useState(props?.trade?.termDate);
  const [isSingleTradeSubmitted, setIsSingleTradeSubmitted] = useState(false);
  const [bCptyName, setBCptyName] = useState("");
  const [lCptyName, setLCptyName] = useState("");
  const [cptyList, setCptyList] = useState<any>();
  const [bMarkExceedStatus, setBMarkExceedStatus] = useState(false);
  const bTickerRef = useRef<any>(null);
  const lTickerRef = useRef<any>(null);
  const [bContractPrice, setBContractPrice] = useState(0);
  const [lContractPrice, setLContractPrice] = useState(0);

  const quantityRef = useRef<any>(null);

  const [loanValueFieldExceedStatus, setLoanValueFieldExceedStatus] =
    useState(false);
  const [lMarkExceedStatus, setLMarkExceedStatus] = useState(false);

  const [isValueWarningPopUp, setValueWarningPopUp] = useState(false);

  const rateRef = useRef<any>(null);
  const [tickerList, setTickerList] = useState<any>();
  const [bTickerFilteredOptions, setBTickerFilteredOptions] = useState<any[]>(
    []
  );
  const [currentFocus, setCurrentFocus] = useState("");
  const bMarkRef = useRef<any>(null);
  const bValueRef = useRef<any>(null);
  const lMarkRef = useRef<any>(null);
  const lValueRef = useRef<any>(null);
  const [isQuantityInvalid, setIsQuantityInvalid] = useState(false);
  const [isContractBookingLoading, setIsContractBookingLoading] =
    useState(false);
  const [borrowValOpen, setBorrowValOpen] = useState(false);
  const [loanValOpen, setLoanValOpen] = useState(false);
  const [thisContractVal, setThisContractVal] = useState("");
  const [borrAcctLimit, setBorrAcctLimit] = useState("");
  const [loanAcctLimit, setLoanAcctLimit] = useState("");
  const [borrCptyIdModal, setBorrCptyIdModal] = useState("");
  const [loanCptyIdModal, setLoanCptyIdModal] = useState("");
  const [
    getCptyDataForBookContractBorrow,
    SetGetCptyDataForBookContractBorrow,
  ] = useState<any>([]);
  const [getCptyDataForBookContractLoan, SetGetCptyDataForBookContractLoan] =
    useState<any>([]);
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  });
  const [outstandingBorrow, setOutstandingBorrow] = useState("");
  const [outstandingLoan, setOutstandingLoan] = useState("");
  const userName = window.localStorage.getItem("username");
  const accessToken = window.localStorage.getItem("refreshtoken");
  const [popupCount, setPopupCount] = useState(0);

  const matchHandler = (event: any) => {
    setCheckedRadio(event?.target?.checked);
  };

  useEffect(() => {
    getCptyList();
    getTickerList();
  }, []);

  const customFilterCpty = createFilter({ ignoreAccents: false });

  const customFilterTicker = (option: any, searchText: any) => {
    if (
      option.data.cusip.toLowerCase().startsWith(searchText.toLowerCase()) ||
      option.data.ticker.toLowerCase().startsWith(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  };
  const onbCptyChange = (value: any) => {
    setBValue(0);
    const contractObj = {
      cptyId: value.cptyId,
      name: "",
      borrow_mark: value.borrow_mark,
      loan_mark: value.loan_mark,
      hse_ind: value.hse_ind,
      hse_rnd: value.hse_rnd,
    };
    setBCpty(contractObj);
    setBCptyName(value.name);
    if (bl == "B" || "b") {
      setBMark(value.borrow_mark);
    } else if (bl == "L" || "l") {
      setLMark(value.loan_mark);
    }
    if (value.loan_mark < 95 || value.loan_mark > 105) {
      setLoanValueFieldExceedStatus(true);
    }
    if (value.borrow_mark < 95 || value.borrow_mark > 105) {
      setLoanValueFieldExceedStatus(true);
    }
    if (!ticker || !ticker?.ticker || _.isEmpty(ticker?.name)) {
      bTickerRef?.current?.focus();
    } else if (!_.isEmpty(ticker) && !quantity) {
      const quantityfocus: any = document.getElementById("bQuantity");
      quantityfocus?.focus();
    } else {
      const rateFocus: any = document.getElementById("bRate");
      rateFocus?.focus();
    }

    if (!_.isEmpty(ticker) && !_.isEmpty(quantity)) {
      const quantityField = parseFloat(quantity);
      let cPrice: any = null;
      let cVal: any = null;
      let mark: any = null;
      if (checkedRadio && !_.isEmpty(bl)) {
        mark = bl?.toUpperCase() == "B" ? value?.borrow_mark : value?.loan_mark;
      } else {
        mark = value?.borrow_mark;
      }

      if (tickerPrice && mark && contractObj && quantityField) {
        cPrice = calculateContractPriceFromValues(
          tickerPrice,
          mark,
          contractObj
        );
        cVal = cPrice * quantityField;

        if (cVal && !_.isNaN(cVal)) {
          const val = cVal.toFixed(2);
          setBValue(val);
        } else {
          setBValue(0);
        }
        cPrice && cPrice > 0 ? setBContractPrice(cPrice) : setBContractPrice(0);
      }
    }
  };

  const onLCptyChange = (value: any) => {
    const contractObj = {
      cptyId: value.cptyId,
      name: "",
      borrow_mark: value.borrow_mark,
      loan_mark: value.loan_mark,
      hse_ind: value.hse_ind,
      hse_rnd: value.hse_rnd,
    };
    setLCpty(contractObj);
    setLCptyName(value.name);

    if (borrow == "B" || "b") {
      setLMark(value.borrow_mark);
    } else if (loan == "L" || "l") {
      setLMark(value.loan_mark);
    }

    if (value.loan_mark < 95 || value.loan_mark > 105) {
      setLMarkExceedStatus(true);
    }
    if (value.borrow_mark < 95 || value.borrow_mark > 105) {
      setLMarkExceedStatus(true);
    }
    if (!ticker || !ticker?.ticker || _.isEmpty(ticker?.name)) {
      lTickerRef?.current?.focus();
    } else if (ticker?.ticker && !quantity) {
      const quantityfocusMatch: any = document.getElementById("lQuantity");
      quantityfocusMatch?.focus();
    } else {
      const rateFocusMatch: any = document.getElementById("lRate");
      rateFocusMatch?.focus();
    }

    if (!_.isEmpty(ticker) && !_.isEmpty(quantity)) {
      const quantityField = parseFloat(quantity);
      let cPrice: any = null;
      let cVal: any = null;
      let mark: any = null;
      if (checkedRadio && !_.isEmpty(bl)) {
        mark = bl?.toUpperCase() == "B" ? value?.borrow_mark : value?.loan_mark;
      } else {
        mark = value?.loan_mark;
      }

      if (tickerPrice && mark && contractObj && quantityField) {
        cPrice = calculateContractPriceFromValues(
          tickerPrice,
          mark,
          contractObj
        );
        cVal = cPrice * quantityField;

        if (cVal && !_.isNaN(cVal)) {
          const val = cVal.toFixed(2);
          setLValue(val);
        } else {
          setLValue(0);
        }
        cPrice && cPrice > 0 ? setLContractPrice(cPrice) : setLContractPrice(0);
      }
    }
  };

  const formatOptionLabelCounter = ({ cptyId, name }: any) => (
    <div style={{ display: "flex" }}>
      <div>{cptyId}</div>
      <div style={{ color: "#000", marginLeft: "10px" }}>{name}</div>
    </div>
  );

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      color: "#000",
      fontSize: "0.7rem",
      backgroundColor: state.isFocused ? "#EAECEF" : null,
      cursor: "pointer",
      zIndex: "9999 !important",
    }),
    control: (base: any) => ({
      ...base,
      fontSize: "0.8rem",
      minWidth: "9rem",
      maxWidth: "9rem",
      marginRight: "1rem",
      borderColor: "#EAECEF",
      ":hover": {
        borderColor: "#EAECEF",
      },
    }),
    valueContainer: (base: any) => ({
      ...base,
      height: "2.4rem",
    }),
    indicatorsContainer: (base: any) => ({
      ...base,
    }),
    menu: (provided: any) => ({
      ...provided,
      width: 300,
      backgroundColor: "#fff",
      zIndex: "9999 !important",
    }),
    input: (provided: any) => ({
      ...provided,
      height: "2rem",
    }),
  };

  const getCptyList = async () => {
    let getCptyTextFieldRes: any = "";

    const cptyListReq = JSON.stringify({
      pageCount: 0,
      pageNumber: 0,
    });

    const token = window.localStorage.getItem("refreshtoken");

    const header = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    getCptyTextFieldRes = await axios.post(
      `${serviceAPIMapping["COUNTERPARTY-SERVICE"].apiRouteURL}${EndPoint.getCptyDetails}`,
      cptyListReq,
      {
        headers: header,
      }
    );
    if (!getCptyTextFieldRes) {
      //setOpen(true)
      //setSnackbarMessage(messages.CPTYDownMessage)
    } else if (getCptyTextFieldRes.status === 200) {
      const cptydataApi = getCptyTextFieldRes.data;
      setCptyList(cptydataApi);
    } else if (getCptyTextFieldRes.status === 401) {
      //logout(channel)
    }
  };

  useEffect(() => {
    if (!checkedRadio) {
      setBL("");
    }
  }, [checkedRadio]);

  const changeBTickerFocus = () => {
    if (!quantity) {
      const quantityfocus: any = document.getElementById("bQuantity");
      quantityfocus?.focus();
    } else {
      const rateFocus: any = document.getElementById("bRate");
      rateFocus?.focus();
    }
  };
  const changeLTickerFocus = () => {
    if (!quantity) {
      const quantityfocusMatch: any = document.getElementById("lQuantity");
      quantityfocusMatch?.focus();
    } else {
      const rateFocusMatch: any = document.getElementById("lRate");
      rateFocusMatch?.focus();
    }
  };
  const onChangeTicker = (value: any) => {
    setBValue(0);
    setLValue(0);
    const splitValue = value.value.split("/");
    const newObj = {
      value: splitValue[0],
      label: splitValue[1],
      sm_id: value.sm_id,
      updatedTime: value.updatedTime,
      name: value.name,
      price: value.price,
      date: value.date,
      cusip: value.cusip,
      ticker: value.ticker,
      cins: value.cins,
      isin: value.isin,
    };
    let bCPrice: any = null;
    let lCPrice: any = null;
    let bCVal: any = null;
    let lCValue: any = null;
    if (value.price && bMark && bCpty && quantity) {
      bCPrice = calculateContractPriceFromValues(value.price, bMark, bCpty);
      bCVal = bCPrice * quantity;
      bCVal && bCVal > 0 ? setBValue(bCVal.toFixed(2)) : setBValue(0);
      bCPrice && bCPrice > 0
        ? setBContractPrice(bCPrice)
        : setBContractPrice(0);
      if (lCpty) {
        lCPrice = calculateContractPriceFromValues(value.price, lMark, lCpty);
        lCValue = lCPrice * quantity;
        setLValue(lCValue.toFixed(2));
        setLContractPrice(lCPrice);
      }
    }
    setTicker(newObj);
    setTickerName(value.name);
    setTickerPrice(value.price);
  };

  const options: any = [];

  let getTickerTextFieldRes: any = "";

  const getTickerList = async () => {
    const accountId = window.localStorage.getItem("activeAccountCode");
    const raw = JSON.stringify({
      pageNumber: 0,
      pageSize: 0,
    });
    const token = window.localStorage.getItem("refreshtoken");

    const header = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    getTickerTextFieldRes = await axios.post(
      `${serviceAPIMapping["SECMASTER-SERVICE"].apiRouteURL}${EndPoint.secMaster}?account_id=${accountId}`,
      raw,
      { headers: header }
    );
    if (!getTickerTextFieldRes) {
      // setOpen(true)
      // settickerSnackbarMessage(messages.TickerDownMessage)
    } else if (getTickerTextFieldRes.status === 200) {
      const tickerdataApi: any = getTickerTextFieldRes.data;
      for (let i = 0; i < tickerdataApi.length; i++) {
        const tempOptions: any = {
          value: tickerdataApi[i].ticker + "/" + tickerdataApi[i].cusip,
          label: tickerdataApi[i].name,
          ticker: tickerdataApi[i].ticker,
          cusip: tickerdataApi[i].cusip,
          name: tickerdataApi[i].name,
          price: tickerdataApi[i].price,
          sm_id: tickerdataApi[i].sm_id,
          isin: tickerdataApi[i].isin,
          cins: tickerdataApi[i].cins,
          date: tickerdataApi[i].date,
          updatedTime: tickerdataApi[i].updatedTime,
        };
        options.push(tempOptions);
      }
      setBTickerFilteredOptions([...options]);
      setTickerList(options);

      // if (tickerSet) {
      //   tickerSet(options)
      // }
      // tickerCusipMap(new Map(options.map((t: any) => [t.cusip, t])))
      // if (tickerListMap) {
      //   tickerListMap(new Map(options.map((t: any) => [t.ticker.toUpperCase(), t])))
      // }
    } else if (getTickerTextFieldRes.status === 401) {
      // logout(channel)
    }
  };

  const formatOptionLabel = ({ label, value }: any) => {
    if (value && value?.length > 0) {
      const splitValue = value.split("/");

      return (
        <div style={{ display: "flex" }}>
          <div>{splitValue[0]}</div>
          <div style={{ color: "#000", marginLeft: "10px" }}>
            {splitValue[1]}
          </div>
          <div style={{ color: "#000", marginLeft: "10px" }}>{label}</div>
        </div>
      );
    }
  };

  const onChangeQuantity = (e: any) => {
    const qty = e.target?.value;
    setQuantity(qty);
    if (isNaN(bValue)) {
      setBValue(0);
    }
    if (e.target.value === "") {
      setBValue(0);
      setLValue(0);
    }
    const quantityField = parseFloat(e.target.value);
    let cPrice: any = null;
    let cPriceisMatch: any = null;
    let cVal: any = null;
    let cValisMatch: any = null;
    if (tickerPrice && bMark && bCpty && quantityField) {
      cPrice = calculateContractPriceFromValues(tickerPrice, bMark, bCpty);
      cVal = cPrice * quantityField;

      if (cVal && cVal > 0 && !_.isNaN(cVal)) {
        const val = cVal.toFixed(2);
        setBValue(val);
      } else {
        setBValue(0);
      }
      cPrice && cPrice > 0 ? setBContractPrice(cPrice) : setBContractPrice(0);
    }

    // if counterparty is selected for match.
    if (tickerPrice && lMark && lCpty) {
      cPriceisMatch = calculateContractPriceFromValues(
        tickerPrice,
        lMark,
        lCpty
      );
      cValisMatch = cPriceisMatch * quantityField;
      setLValue(isNaN(cValisMatch) ? 0 : cValisMatch.toFixed(2));
      setLContractPrice(cPriceisMatch);
    }
  };

  const preventMinus = (e: any) => {
    if (e.code === constants.NumpadSubtract || e.code === constants.Minus) {
      e.preventDefault();
    }
  };

  const onChangeMark = (e: any) => {
    setBMark(e.target.value);
    const cPrice = calculateContractPriceFromValues(
      tickerPrice,
      e.target.value,
      bCpty
    );
    const cVal = cPrice * quantity;
    setBValue(isNaN(cVal) ? "" : cVal.toFixed(2));
  };

  const onBContractValueChange = (e: any) => {
    const newContractPrice: any = e.target.value / quantity;
    setBContractPrice(newContractPrice.toFixed(2));
    setBValue(e.target.value);

    if (e.target.value > 250000000) {
      setLoanValueFieldExceedStatus(true);
    }
  };

  const onLContractValueChange = (e: any) => {
    const newContractPriceIsMatch: any = e.target.value / quantity;
    setLContractPrice(newContractPriceIsMatch.toFixed(2));

    setLValue(e.target.value);

    if (e.target.value > 250000000) {
      setLoanValueFieldExceedStatus(true);
    }
  };

  const onLMarkChange = (e: any) => {
    setLMark(e.target.value);
    const cPrice = calculateContractPriceFromValues(
      tickerPrice,
      e.target.value,
      lCpty
    );
    const cVal = cPrice * quantity;
    setLValue(isNaN(cVal) ? "" : cVal.toFixed(2));
  };

  const onBMarkBlur = () => {
    if (bMark && (bMark < 95 || bMark > 105)) {
      setBMarkExceedStatus(true);
    }
  };

  const handleLetterSelect = (e: any) => {
    const allowedInputValue = /[cnCN]/gm.test(e.key);
    if (!allowedInputValue) {
      e.preventDefault();
    }
  };

  const handleLetterSelectBL = (e: any) => {
    const allowedInputValue = /[blBL]/gm.test(e.key);
    if (!allowedInputValue) {
      e.preventDefault();
    }
  };

  const onBCashNonCashChange = (e: any) => {
    const result = e.target.value.replace(/[^a-z]/gi, "");
    if (!_.isEmpty(result)) {
      setBCN(result?.toUpperCase());
    } else setBCN(result);
  };

  const onLCashNonCashChange = (e: any) => {
    const result = e.target.value.replace(/[^a-z]/gi, "");
    if (!_.isEmpty(result)) {
      setLCN(result?.toUpperCase());
    } else setLCN(result);
  };

  const handleLetterAlloweDiv = (e: any) => {
    const alloweOnlyLetter = /[0-9]/gm.test(e.key);
    if (!alloweOnlyLetter) {
      e.preventDefault();
    }
  };

  const handleLetterAllowe = (e: any) => {
    const alloweOnlyLetter = /[A-Z0-9 !@#$%&*()+=?]/gm.test(e.key.toUpperCase());
    if (!alloweOnlyLetter) {
      e.preventDefault();
    }
  };

  const onSubmit = () => {
    setIsSingleTradeSubmitted(true);
    if (validateSubmitForm()) {
      const tradeList: any[] = [];
      if (checkedRadio) {
        const tradeRow = {
          collatoral_code: "C",
          collatoral_type: "",
          country: "",
          cpty: bCpty?.cptyId,
          currency: "",
          div: validateDiv(bDiv) ? bDiv : 100,
          external_contract_id: "T",
          external_source: "",
          loan_value: bValue,
          mark: lMark !== "" ? parseInt(bMark) : 0,
          profit_center: bPC ? bPC : "",
          quantity: quantity,
          rate: bRate,
          symbol: ticker?.ticker,
          term_date: termDate ? moment(termDate)?.format("MM/DD/YYYY") : "",
          ticker: ticker?.ticker,
          type: bl?.toUpperCase(),
          sec_id: ticker?.ticker,
          tickerCusip: ticker?.cusip,
          trader: userName,
          cpty_name: bCptyName,
          mkt_price: tickerPrice,
          contract_price: bContractPrice,
          c_n: bCN ? bCN : "",
          uiTradeId: 0,
        };
        tradeList.push(tradeRow);
        onOpenContractValueByCptyID(tradeList);
      } else {
        const borrowRow = {
          collatoral_code: "C",
          collatoral_type: "",
          country: "",
          cpty: bCpty?.cptyId,
          currency: "",
          div: validateDiv(bDiv) ? bDiv : 100,
          external_contract_id: "T",
          external_source: "",
          loan_value: bValue,
          mark: lMark !== "" ? parseInt(bMark) : 0,
          profit_center: bPC ? bPC : "",
          quantity: quantity,
          rate: bRate,
          symbol: ticker?.ticker,
          term_date: termDate ? moment(termDate)?.format("MM/DD/YYYY") : "",
          ticker: ticker?.ticker,
          type: "B",
          sec_id: ticker?.ticker,
          tickerCusip: ticker?.cusip,
          trader: userName,
          cpty_name: bCptyName,
          mkt_price: tickerPrice,
          contract_price: bContractPrice,
          c_n: bCN ? bCN : "",
          uiTradeId: 0,
        };

        const loanRow = {
          collatoral_code: "C",
          collatoral_type: "",
          country: "",
          cpty: lCpty?.cptyId,
          currency: "",
          div: validateDiv(lDiv) ? lDiv : 100,
          external_contract_id: "T",
          external_source: "",
          loan_value: lValue,
          mark: lMark !== "" ? parseInt(lMark) : 0,
          profit_center: lPC ? lPC : "",
          quantity: quantity,
          rate: lRate,
          symbol: ticker?.ticker,
          term_date: termDate ? moment(termDate)?.format("MM/DD/YYYY") : "",
          ticker: ticker?.ticker,
          type: "L",
          sec_id: ticker?.ticker,
          tickerCusip: ticker?.cusip,
          trader: userName,
          cpty_name: lCptyName,
          mkt_price: tickerPrice,
          contract_price: lContractPrice,
          c_n: lCN ? lCN : "",
          uiTradeId: 0,
        };

        tradeList.push(borrowRow);
        tradeList.push(loanRow);

        onOpenContractValueByCptyID(tradeList);
      }
    }
  };

  const onOpenContractValueByCptyID = async (Data: any) => {
    let response: any = "";
    let result: any = "";
    let reqObj: any = {};
    const reqArr: any = [];
    for (let d = 0; d < Data.length; d++) {
      Data[d].type = Data[d].type.toUpperCase();
      reqObj = {
        cpty_id: Data[d].cpty,
        bl: Data[d].type,
      };
      reqArr.push(reqObj);
    }
    const reqBody = JSON.stringify({
      openContractValueByCptyIDDTOList: reqArr,
    });
    axios.defaults.headers.common = { Authorization: `Bearer ${accessToken}` };
    response = await axios.post(
      `${serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL}/${EndPoint.getOpenContractValueByCptyID}`,
      reqBody,
      {
        headers: headers,
      }
    );
    if (!response) {
    } else if (response && response != undefined && response.status === 200) {
      result = await response.data;
      for (let d = 0; d < Data.length; d++) {
        const dData: any = Data[d];
        if (
          typeof dData.loan_value === "string" &&
          !Number.isNaN(parseFloat(dData.loan_value))
        ) {
          dData.loan_value = parseFloat(dData.loan_value);
          dData.contract_price = dData.loan_value / dData.quantity;
        }
        if (result.result.length > 0) {
          for (let i = 0; i < result.result.length; i++) {
            const iResult: any = result.result[i];
            if (iResult?.error === "Success") {
              const counterPartyContract = cptyList?.find(
                (x: any) => x?.cptyId === iResult?.cpty_id?.toUpperCase()
              );
              if (counterPartyContract) {
                const borrowAcctLimit = counterPartyContract?.borr_acct_limit;
                const loanAcctLimit = counterPartyContract?.loan_acct_limit;
                const outstandingValue = iResult?.total_col_value;
                const newValue = dData.loan_value + outstandingValue;
                if (iResult.bl === "B" && dData.type === "B") {
                  if (newValue > borrowAcctLimit) {
                    setThisContractVal(formatter.format(dData.loan_value));
                    setBorrAcctLimit(formatter.format(borrowAcctLimit));
                    setOutstandingBorrow(formatter.format(outstandingValue));
                    setBorrCptyIdModal(dData.cpty);
                    SetGetCptyDataForBookContractBorrow([Data[d]]);
                    setPopupCount((prev: number) => {
                      return prev + 1;
                    });
                    setBorrowValOpen(true);
                  } else {
                    bookContracts([Data[d]]);
                  }
                } else if (iResult.bl === "L" && dData.type === "L") {
                  if (newValue > loanAcctLimit) {
                    setThisContractVal(formatter.format(dData.loan_value));
                    setLoanAcctLimit(formatter.format(loanAcctLimit));
                    setOutstandingLoan(formatter.format(outstandingValue));
                    setLoanCptyIdModal(dData.cpty);
                    SetGetCptyDataForBookContractLoan([Data[d]]);
                    setPopupCount((prev: number) => {
                      return prev + 1;
                    });
                    setLoanValOpen(true);
                  } else {
                    bookContracts([Data[d]]);
                  }
                }
              }
            }
          }
        } else {
          bookContracts(Data[d]);
        }
      }
    } else if (response && response?.status === 401) {
      //logout(channel)
    } else {
      // setOpen(true)
      // setSnackbarMessage(messages.contractBookMessage)
    }
  };

  const bookContracts = async (trades: any) => {
    setIsContractBookingLoading(true);

    //isContractStatusEnabled = false
    let bookContractRes: any = "";

    //const statusRowData: any = [...rowData]
    let errors: any = [];
    try {
      const req = JSON.stringify(trades);
      axios.defaults.headers.common = {
        Authorization: `Bearer ${accessToken}`,
      };
      bookContractRes = await axios.post(
        `${serviceAPIMapping["CONTRACT-BOOKING-SERVICE"].apiRouteURL}${EndPoint.bookContract}`,
        req,
        {
          headers: headers,
        }
      );
      if (!bookContractRes) {
        setIsContractBookingLoading(false);
      } else if (bookContractRes.status === 200) {
        const bookContractData = bookContractRes.data;
        for (let i = 0; i < bookContractData.length; i++) {
          if (
            bookContractData[i].hasError === true &&
            bookContractData[0].errorCategory !== "Invalid quantity."
          ) {
            setIsQuantityInvalid(false);
          }

          if (bookContractData[i].hasError === true) {
            errors.push(
              bookContractData[i].status + " " + bookContractData[i].error
            );
          }
        }

        if (errors.length > 0) {
          errors = _.uniq(errors);
          //   let error = messages.statusError + '\n\n Error(s): \n'
          //   errors.map((e: any) => {
          //     error = error + e + '\n'
          //   })
        } else {
          toast.success("contracts sent successfully");
        }
      } else if (bookContractRes.status === 401) {
        //logout(channel)
      } else if (bookContractRes.status != 200) {
        const bookContractJson = bookContractRes.data;
        if (bookContractJson.error) {
          const error = bookContractJson.error;
        }
      }
    } catch (err) {
      setIsContractBookingLoading(false);
    } finally {
      setIsContractBookingLoading(false);
      setPopupCount((prev: number) => {
        if(prev <=0 && errors.length === 0){
          props?.onCloseBookTrade();
        }

        return prev;
      });
      
      if (props?.setIsContractBookingLoading) {
        props?.setIsContractBookingLoading(isContractBookingLoading);
      }
    }
  };

  const validateSubmitForm = () => {
    let isValidForm = true;
    const isValidCptyTicker = validateCpty(bCpty) && validateTicker(ticker);
    const isQuantityRateMarkValid =
      validateQuantity(_.isNaN(quantity) ? "" : parseInt(quantity)) &&
      validateRate(_.isNaN(bRate) ? "" : parseFloat(bRate)) &&
      bMark &&
      !_.isNaN(bMark) &&
      parseFloat(bMark) > 0;
    const validValue = validateValue(bValue);
    const validCN = bCN ? validateC_N(bCN?.toUpperCase()) : true;
    const isValidPC = bPC ? validateProfitCenter(bPC?.toUpperCase()) : true;
    const isValidTermDate = termDate ? validateTermDate(termDate) : true;
    const isValidBL = checkedRadio ? validateBorrowAndLoan(bl ?? "") : true;

    isValidForm =
      isValidCptyTicker &&
      isQuantityRateMarkValid &&
      isValidBL &&
      validValue &&
      validCN &&
      isValidPC &&
      isValidTermDate;

    if (!checkedRadio) {
      const isValidCptyTickerMatch =
        validateCpty(lCpty) && validateTicker(ticker);
      const isValidQuantityRateMarkMatch =
        validateQuantity(quantity) &&
        validateRate(lRate) &&
        lMark &&
        !_.isNaN(lMark) &&
        parseFloat(lMark) > 0;
      const isValidValue = validateValue(lValue);
      const validCNMatch = lCN ? validateC_N(lCN?.toUpperCase()) : true;
      const isValidPCMatch = lPC
        ? validateProfitCenter(lPC?.toUpperCase())
        : true;

      isValidForm =
        isValidForm &&
        isValidCptyTickerMatch &&
        isValidQuantityRateMarkMatch &&
        isValidValue &&
        validCNMatch &&
        isValidPCMatch;
    }

    return isValidForm;
  };

  const onBMarkWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setBMarkExceedStatus(false);
  };

  const warningBMarkNo = () => {
    setBMarkExceedStatus(false);
    setBMark("");
    setTimeout(() => {
      bMarkRef.current.focus();
    }, 500);
  };
  const warningBMarkYes = () => {
    setBMarkExceedStatus(false);
    setTimeout(() => {
      bValueRef.current.focus();
    }, 500);
  };

  const onQuantityWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setIsQuantityInvalid(false);
  };

  const quantitywarningYes = () => {
    setIsQuantityInvalid(false);
    setQuantity("");
    setBValue("");
    setLValue("");
    setTimeout(() => {
      const bQuantity = document.getElementById("bQuantity");
      bQuantity?.focus();
    }, 100);
  };

  const onQuantityBlur = (e: any) => {
    if (e.target?.value?.length > 12) {
      setIsQuantityInvalid(true);
    } else {
      const quantityField = parseFloat(e.target.value);
      let cPrice: any = null;
      let cPriceisMatch: any = null;
      let cVal: any = null;
      let cValisMatch: any = null;

      if (tickerPrice && bMark && bCpty && quantityField) {
        cPrice = calculateContractPriceFromValues(tickerPrice, bMark, bCpty);
        cVal = cPrice * quantityField;
        setBValue(isNaN(cVal) ? "" : cVal.toFixed(2));
        setBContractPrice(cPrice);
        if (cVal > 999999999999.99) {
          setValueWarningPopUp(true);
        } else if (cVal > 250000000) {
          setLoanValueFieldExceedStatus(true);
        }
      }
      if (lCpty && tickerPrice && lMark && quantityField) {
        cPriceisMatch = calculateContractPriceFromValues(
          tickerPrice,
          lMark,
          lCpty
        );
        cValisMatch = cPriceisMatch * quantityField;
        setLValue(isNaN(cValisMatch) ? "" : cValisMatch.toFixed(2));
        setLContractPrice(cPriceisMatch);

        if (cValisMatch > 999999999999.99) {
          setValueWarningPopUp(true);
        } else if (cValisMatch > 250000000) {
          setLoanValueFieldExceedStatus(true);
        }
      }
    }
  };

  const warningNo = () => {
    setLoanValueFieldExceedStatus(false);
    setQuantity("");
    setBValue("");
    setLValue("");
    setTimeout(() => {
      if (currentFocus == "lQuantity" || currentFocus == "lValue") {
        const lQuantity = document.getElementById("lQuantity");
        lQuantity?.focus();
      } else {
        const bQuantity = document.getElementById("bQuantity");
        bQuantity?.focus();
      }
    }, 100);
  };
  const warningYes = () => {
    setLoanValueFieldExceedStatus(false);
    setTimeout(() => {
      changeCurrentFocus();
    }, 100);
  };

  const changeCurrentFocus = () => {
    switch (currentFocus) {
      case "bQuantity": {
        if (quantity && bRate && bValue) {
          const bCN: any = document.getElementById("bCN");
          bCN?.focus();
        } else {
          rateRef?.current.focus();
        }
        break;
      }
      case "lQuantity": {
        if (quantity && bRate && bValue) {
          const lCN: any = document.getElementById("lCN");
          lCN?.focus();
        } else {
          const rateFocusMatch: any = document.getElementById("lRate");
          rateFocusMatch?.focus();
        }
        break;
      }
      case "bValue": {
        const bCN: any = document.getElementById("bCN");
        bCN?.focus();
        break;
      }
      case "lValue": {
        const lCN: any = document.getElementById("lCN");
        lCN?.focus();
        break;
      }
    }
  };

  const onLoanValueExceedWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setLoanValueFieldExceedStatus(false);
  };

  const onValueExceedWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setValueWarningPopUp(false);
  };

  const onValueWarningOk = () => {
    setValueWarningPopUp(false);
    setQuantity("");
    setBValue("");
    setLValue("");
    setTimeout(() => {
      const bQuantity = document.getElementById("bQuantity");
      bQuantity?.focus();
    }, 100);
  };

  const onLMarkExceedWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setLMarkExceedStatus(false);
  };

  const warningLMarkNo = () => {
    setLMarkExceedStatus(false);
    setLMark("");
    setTimeout(() => {
      lMarkRef.current.focus();
    }, 500);
  };
  const warningLMarkYes = () => {
    setLMarkExceedStatus(false);
    setTimeout(() => {
      lValueRef.current.focus();
    }, 500);
  };

  const onLMarkBlur = () => {
    if (lMark && (lMark < 95 || lMark > 105)) {
      setLMarkExceedStatus(true);
    }
  };

  const onBorrowLimitExceedWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    setBorrowValOpen(false);
  };

  const onLoanLimitExceedWarningClose = (event: any, reason: any) => {
    if (reason && (reason == "backdropClick" || reason == "escapeKeyDown")) {
      return;
    }
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    setLoanValOpen(false);
  };

  const onClickBorrowValYes = () => {
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    bookContracts(getCptyDataForBookContractBorrow);
    setBorrowValOpen(false);
  };
  const onClickBorrowValNo = () => {
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    setBorrowValOpen(false);
  };
  const onClickLoanValYes = () => {
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    bookContracts(getCptyDataForBookContractLoan);
    setLoanValOpen(false);
  };
  const onClickLoanValNo = () => {
    setPopupCount((prev: number) => {
      return prev - 1;
    });
    setLoanValOpen(false);
  };

  return (
    <>
      <div className="w-100 d-flex justify-content-between">
        <FormGroup>
          <FormControlLabel
            label=""
            control={
              <Checkbox
                onClick={matchHandler}
                checked={checkedRadio}
                name="non-match"
              />
            }
          />
        </FormGroup>
        <div>
          <form
            className="d-flex flex-row mb-3 mt-3"
            noValidate
            autoComplete="off"
          >
            <div>
              {checkedRadio ? (
                <TextField
                  size="small"
                  className="me-3"
                  id="bl"
                  label="B/L"
                  value={bl}
                  onChange={(event: any) => {
                    if (!_.isEmpty(event?.target?.value)) {
                      setBL(event?.target?.value?.toUpperCase());
                    } else {
                      setBL(event?.target?.value);
                    }
                  }}
                  onKeyDown={handleLetterSelectBL}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    inputProps: { maxLength: 1 },
                    style: { textTransform: "uppercase" },
                  }}
                  sx={{ width: "3rem" }}
                />
              ) : (
                <TextField
                  size="small"
                  className="me-3"
                  id="b"
                  label="B"
                  InputLabelProps={{ shrink: true }}
                  value={"B"}
                  disabled
                  sx={{ width: "3rem" }}
                />
              )}

              {checkedRadio && !bl && isSingleTradeSubmitted && (
                <div className="error-style">{messages.enterBLMessage}</div>
              )}
            </div>
            <div>
              <WindowedSelect
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                tabIndex={0}
                onChange={onbCptyChange}
                placeholder="Cpty"
                filterOption={customFilterCpty}
                getOptionValue={(option: any) => option.name}
                getOptionLabel={(option: any) => option.cptyId}
                formatOptionLabel={formatOptionLabelCounter}
                options={cptyList}
                windowThreshold={0}
                styles={customStyles}
                value={bCpty}
              />
              {bCpty !== "" && (
                <div className="counterParty-Name mb-3">{bCptyName}</div>
              )}
              {isSingleTradeSubmitted && !validateCpty(bCpty) && (
                <div className="error-style ">
                  {messages.singleTradeValidationMessage}
                </div>
              )}
            </div>

            <div>
              <WindowedSelect
                components={{
                  DropdownIndicator: () => null,
                  IndicatorSeparator: () => null,
                }}
                tabIndex={0}
                onChange={(value: any) => {
                  changeBTickerFocus();
                  onChangeTicker(value);
                }}
                placeholder="Ticker"
                filterOption={customFilterTicker}
                ref={bTickerRef}
                menuShouldScrollIntoView={true}
                getOptionLabel={(option: any) => option.ticker}
                getOptionValue={(option: any) => option.ticker}
                options={bTickerFilteredOptions}
                formatOptionLabel={formatOptionLabel}
                windowThreshold={0}
                styles={customStyles}
                value={ticker}
                id="bTicker"
              />
              {validateTicker(ticker) && (
                <div className="counterParty-Name mb-3">
                  <span className="ticker-price">(${tickerPrice})</span>
                  <span className="ticker-name">{tickerName}</span>
                </div>
              )}
              {isSingleTradeSubmitted && !validateTicker(ticker) && (
                <div className="error-style">
                  {messages.singleTradeValidationMessage}
                </div>
              )}
            </div>
            <div>
              <TextField
                size="small"
                className="me-3"
                id="bQuantity"
                label="Quantity"
                value={quantity}
                onChange={onChangeQuantity}
                onKeyPress={preventMinus}
                type="number"
                InputProps={{ inputProps: { min: 0 } }}
                ref={quantityRef}
                onBlur={onQuantityBlur}
                onKeyDown={validateQuantity}
                onFocus={() => setCurrentFocus("bQuantity")}
                InputLabelProps={{ shrink: true }}
                sx={{ width: "7rem" }}
              />
              {isSingleTradeSubmitted && !quantity && (
                <div className="error-style">
                  {messages.singleTradeValidationMessage}
                </div>
              )}
              {isSingleTradeSubmitted &&
                quantity &&
                (quantity <= 0 || quantity % 1 !== 0) && (
                  <div className="error-style">
                    {messages.enterPositiveInteger}
                  </div>
                )}
            </div>
            <div>
              <TextField
                size="small"
                className="me-3"
                id="bRate"
                label="Rate"
                type="number"
                value={bRate}
                onChange={(e: any) => setBRate(e?.target?.value)}
                InputLabelProps={{ shrink: true }}
                sx={{ width: "5rem" }}
              />
              {isSingleTradeSubmitted && !bRate && (
                <div className="error-style">
                  {messages.singleTradeValidationMessage}
                </div>
              )}

              {isSingleTradeSubmitted && bRate && !validateRate(bRate) && (
                <div className="error-style">{messages.enterValidRate}</div>
              )}
            </div>
            <div>
              <TextField
                size="small"
                className="me-3"
                id="bMark"
                label="Mark"
                value={bMark && Math.abs(bMark)}
                onChange={onChangeMark}
                type="number"
                onInput={(e: any) =>
                  (e.target.value = e.target.value.slice(0, 3))
                }
                onKeyPress={preventMinus}
                ref={bMarkRef}
                onBlur={onBMarkBlur}
                InputLabelProps={{ shrink: true }}
                sx={{ width: "5rem" }}
              />
              {isSingleTradeSubmitted && (!bMark || (bMark && bMark == 0)) && (
                <div className="error-style">
                  {messages.singleTradeValidationMessage}
                </div>
              )}
              {isSingleTradeSubmitted && bMark && bMark < 0 && (
                <div className="error-style">
                  {messages.enterPositiveNumberMessage}
                </div>
              )}
            </div>
            <div>
              <TextField
                size="small"
                className="me-3"
                id="bValue"
                label="Value"
                type="number"
                onKeyPress={preventMinus}
                onFocus={() => setCurrentFocus("bValue")}
                onChange={onBContractValueChange}
                value={bValue}
                ref={bValueRef}
                InputLabelProps={{ shrink: true }}
                sx={{ width: "8rem" }}
              />
              {isSingleTradeSubmitted && !bValue && (
                <div className="error-style">
                  {messages.singleTradeValidationMessage}
                </div>
              )}
              {isSingleTradeSubmitted && bValue && bValue < 0 && (
                <div className="error-style">
                  {messages.enterPositiveNumberMessage}
                </div>
              )}
            </div>
            <div>
              <TextField
                sx={{ width: "4rem" }}
                size="small"
                className="me-3"
                label="C/N"
                value={bCN}
                onChange={onBCashNonCashChange}
                style={{ textTransform: "uppercase" }}
                onKeyPress={handleLetterSelect}
                id="bCN"
                InputProps={{
                  inputProps: { maxLength: 1 },
                  style: { textTransform: "uppercase" },
                }}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div>
              <TextField
                sx={{ width: "4rem" }}
                size="small"
                className="me-3"
                id="bDiv"
                onKeyPress={handleLetterAlloweDiv}
                label="Div"
                value={bDiv}
                onChange={(e) => {
                  setBDiv(e?.target?.value);
                }}
                InputProps={{ inputProps: { maxLength: 3 } }}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div>
              <TextField
                sx={{ width: "4rem" }}
                size="small"
                className="me-3"
                id="pc"
                label="P/C"
                value={bPC}
                onChange={(e) => {
                  if (e?.target?.value && !_.isEmpty(e?.target?.value)) {
                    setBPC(e?.target?.value?.toUpperCase());
                  } else {
                    setBPC(e?.target?.value);
                  }
                }}
                InputProps={{ inputProps: { maxLength: 1 } }}
                onKeyPress={handleLetterAllowe}
                InputLabelProps={{ shrink: true }}
              />
            </div>
            <div>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  disablePast
                  openTo="day"
                  className="onFocusOutTermDateID"
                  views={["year", "month", "day"]}
                  minDate={moment().toDate()}
                  value={termDate}
                  inputFormat="yyyy-MM-dd"
                  InputProps={{
                    notched: false,
                    style: { fontSize: 13, color: "#212529" },
                  }}
                  onChange={(newValue) => {
                    setTermDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      variant="outlined"
                      sx={{
                        "& .MuiInputBase-input": {
                          height: "0.4rem",
                          width: "4.4rem",
                          border: "none",
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      }}
                      style={{
                        border: "1px solid #eaecef",
                        fontSize: "1rem",
                        color: "#212529",
                      }}
                      className="inputStyleNew"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
              {termDate && !validateTermDate(termDate) && (
                <div className="error-style">
                  {messages.selectFutureDateMessage}
                </div>
              )}
            </div>
          </form>
          {!checkedRadio && (
            <form
              className="w-100 d-flex flex-row mt-3 mb-3"
              noValidate
              autoComplete="off"
            >
              <TextField
                InputLabelProps={{ shrink: true }}
                size="small"
                className="me-3"
                id="l"
                label="L"
                value={"L"}
                disabled
                sx={{ width: "3rem !important" }}
              />
              <div>
                <WindowedSelect
                  components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                  }}
                  tabIndex={0}
                  onChange={onLCptyChange}
                  placeholder="Cpty"
                  filterOption={customFilterCpty}
                  getOptionValue={(option: any) => option.name}
                  getOptionLabel={(option: any) => option.cptyId}
                  formatOptionLabel={formatOptionLabelCounter}
                  options={cptyList}
                  windowThreshold={0}
                  styles={customStyles}
                  value={lCpty}
                />
                {bCpty !== "" && (
                  <div className="counterParty-Name">{lCptyName}</div>
                )}
                {isSingleTradeSubmitted && !validateCpty(lCpty) && (
                  <div className="error-style">
                    {messages.singleTradeValidationMessage}
                  </div>
                )}
              </div>
              <div>
                <div>
                  <div>
                    <WindowedSelect
                      components={{
                        DropdownIndicator: () => null,
                        IndicatorSeparator: () => null,
                      }}
                      tabIndex={0}
                      onChange={(value: any) => {
                        changeLTickerFocus();
                        onChangeTicker(value);
                      }}
                      placeholder="Ticker"
                      options={tickerList}
                      formatOptionLabel={formatOptionLabel}
                      windowThreshold={0}
                      filterOption={customFilterTicker}
                      styles={customStyles}
                      value={ticker}
                      getOptionLabel={(option: any) => option.ticker}
                      getOptionValue={(option: any) => option.ticker}
                      id="lTicker"
                      ref={lTickerRef}
                    />
                  </div>
                  {validateTicker(ticker) && (
                    <div className="counterParty-Name mb-3">
                      <span className="ticker-price">(${tickerPrice})</span>
                      <span className="ticker-name">{tickerName}</span>
                    </div>
                  )}
                  {!checkedRadio &&
                    isSingleTradeSubmitted &&
                    !validateTicker(ticker) && (
                      <div className="error-style">
                        {messages.singleTradeValidationMessage}
                      </div>
                    )}
                </div>
              </div>
              <div>
                <TextField
                  size="small"
                  className="me-3"
                  id="lQuantity"
                  label="Quantity"
                  value={quantity}
                  onChange={onChangeQuantity}
                  onKeyPress={preventMinus}
                  type="number"
                  InputProps={{ inputProps: { min: 0 } }}
                  InputLabelProps={{ shrink: true }}
                  ref={quantityRef}
                  onBlur={onQuantityBlur}
                  onKeyDown={validateQuantity}
                  onFocus={() => setCurrentFocus("lQuantity")}
                  sx={{ width: "7rem" }}
                />
                {isSingleTradeSubmitted && !quantity && (
                  <div className="error-style">
                    {messages.singleTradeValidationMessage}
                  </div>
                )}
                {isSingleTradeSubmitted &&
                  quantity &&
                  (quantity <= 0 || quantity % 1 !== 0) && (
                    <div className="error-style">
                      {messages.enterPositiveInteger}
                    </div>
                  )}
              </div>
              <div>
                <TextField
                  size="small"
                  className="me-3"
                  id="lRate"
                  label="Rate"
                  type="number"
                  value={lRate}
                  onChange={(e: any) => setLRate(e?.target?.value)}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "5rem" }}
                />
                {isSingleTradeSubmitted && !lRate && (
                  <div className="error-style">
                    {messages.singleTradeValidationMessage}
                  </div>
                )}

                {isSingleTradeSubmitted && lRate && !validateRate(lRate) && (
                  <div className="error-style">{messages.enterValidRate}</div>
                )}
              </div>
              <div>
                <TextField
                  size="small"
                  className="me-3"
                  id="lMark"
                  label="Mark"
                  value={lMark && Math.abs(lMark)}
                  onChange={onLMarkChange}
                  type="number"
                  onInput={(e: any) =>
                    (e.target.value = e.target.value.slice(0, 3))
                  }
                  onKeyPress={preventMinus}
                  ref={lMarkRef}
                  onBlur={onLMarkBlur}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "5rem" }}
                />
                {isSingleTradeSubmitted &&
                  (!lMark || (lMark && lMark == 0)) && (
                    <div className="error-style">
                      {messages.singleTradeValidationMessage}
                    </div>
                  )}
                {isSingleTradeSubmitted && lMark && lMark < 0 && (
                  <div className="error-style">
                    {messages.enterPositiveNumberMessage}
                  </div>
                )}
              </div>
              <div>
                <TextField
                  size="small"
                  className="me-3"
                  id="lValue"
                  label="Value"
                  type="number"
                  onKeyPress={preventMinus}
                  onFocus={() => setCurrentFocus("bValue")}
                  onChange={onLContractValueChange}
                  value={lValue}
                  ref={lValueRef}
                  InputLabelProps={{ shrink: true }}
                  sx={{ width: "8rem" }}
                />
                {isSingleTradeSubmitted && !lValue && (
                  <div className="error-style">
                    {messages.singleTradeValidationMessage}
                  </div>
                )}
                {isSingleTradeSubmitted && lValue && lValue < 0 && (
                  <div className="error-style">
                    {messages.enterPositiveNumberMessage}
                  </div>
                )}
              </div>
              <div>
                <TextField
                  sx={{ width: "4rem", textTransform: "uppercase" }}
                  size="small"
                  className="me-3"
                  label="C/N"
                  value={lCN}
                  onChange={onLCashNonCashChange}
                  onKeyPress={handleLetterSelect}
                  id="lCN"
                  InputProps={{
                    inputProps: { maxLength: 1 },
                    style: { textTransform: "uppercase" },
                  }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div>
                <TextField
                  sx={{ width: "4rem" }}
                  size="small"
                  className="me-3"
                  id="lDiv"
                  label="Div"
                  value={lDiv}
                  onChange={(e) => {
                    setLDiv(e?.target?.value);
                  }}
                  onKeyPress={handleLetterAlloweDiv}
                  InputProps={{ inputProps: { maxLength: 3 } }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div>
                <TextField
                  sx={{ width: "4rem" }}
                  size="small"
                  className="me-3"
                  id="pc"
                  label="P/C"
                  value={lPC}
                  onChange={(e) => {
                    if (e?.target?.value && !_.isEmpty(e?.target?.value)) {
                      setLPC(e?.target?.value?.toUpperCase());
                    } else {
                      setLPC(e?.target?.value);
                    }
                  }}
                  onKeyPress={handleLetterAllowe}
                  InputProps={{ inputProps: { maxLength: 1 } }}
                  InputLabelProps={{ shrink: true }}
                />
              </div>
              <div>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                    disablePast
                    openTo="day"
                    className="onFocusOutTermDateID"
                    views={["year", "month", "day"]}
                    minDate={moment().toDate()}
                    value={termDate}
                    inputFormat="yyyy-MM-dd"
                    InputProps={{
                      notched: false,
                      style: { fontSize: 13, color: "#212529" },
                    }}
                    onChange={(newValue) => {
                      setTermDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        variant="outlined"
                        sx={{
                          "& .MuiInputBase-input": {
                            height: "0.4rem",
                            width: "4.4rem",
                            border: "none",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        style={{
                          border: "1px solid #eaecef",
                          fontSize: "0.8rem",
                          color: "#212529",
                        }}
                        className="inputStyleNew"
                        {...params}
                      />
                    )}
                  />
                </LocalizationProvider>
                {termDate && !validateTermDate(termDate) && (
                  <div className="error-style">
                    {messages.selectFutureDateMessage}
                  </div>
                )}
              </div>
            </form>
          )}
        </div>
        <div className="d-flex justify-content-end align-items-end me-50">
          <Button
            variant="contained"
            style={{
              backgroundColor: !validateSubmitForm() ? "" : "#1E355E",
              color: "white",
            }}
            disabled={!validateSubmitForm()}
            onClick={onSubmit}
          >
            Submit
          </Button>
        </div>
        <ToastContainer />
      </div>

      <Dialog
        open={bMarkExceedStatus}
        onClose={onBMarkWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="invalid-mark"
      >
        <DialogTitle
          sx={{ backgroundColor: "#1E355E" }}
          id="alert-dialog-title"
        >
          <Typography variant="h6" sx={{ color: "white" }}>
            Warning
          </Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="invalid-mark">
            Cparty Mark is between 95 or 105
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => warningBMarkYes()}
          >
            Yes
          </Button>
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => warningBMarkNo()}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isQuantityInvalid}
        onClose={onQuantityWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="invalid-quantity"
      >
        <DialogTitle
          className="d-flex align-items-center p-2"
          sx={{ backgroundColor: "#1E355E" }}
          id="alert-dialog-title"
        >
          <Typography variant="h6" sx={{ color: "white" }}>
            Warning
          </Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="invalid-quantity">
            <div>You cannot enter a quantity greater than 999,999,999,999.</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            style={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => quantitywarningYes()}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={loanValueFieldExceedStatus}
        onClose={onLoanValueExceedWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="invalid-loan-value"
      >
        <DialogTitle
          sx={{ backgroundColor: "#1E355E", color: "white" }}
          id="invalid-loan-value"
        >
          Warning
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="invalid-quantity">
            Loan value entered is bigger than 250M. Do you want to continue?
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => warningYes()}
          >
            Yes
          </Button>
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => warningNo()}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={isValueWarningPopUp}
        onClose={onValueExceedWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="invalid-contract-value"
      >
        <DialogTitle
          sx={{ backgroundColor: "#1E355E" }}
          id="alert-dialog-title"
        >
          <Typography variant="h6" sx={{ color: "white" }}>
            Warning
          </Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="invalid-contract-value">
            Contract value cannot exceed to 999,999,999,999.99. Please update
            the Quantity.
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            variant="contained"
            onClick={() => onValueWarningOk()}
            sx={{ backgroundColor: "#1E355E" }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={lMarkExceedStatus}
        onClose={onLMarkExceedWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="invalid-Cparty-mark-value"
      >
        <DialogTitle
          sx={{ backgroundColor: "#1E355E" }}
          id="alert-dialog-title"
        >
          <Typography variant="h6" sx={{ color: "white" }}>
            Warning
          </Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="invalid-Cparty-mark-value">
            Cparty Mark is between 95 or 105
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            variant="contained"
            onClick={() => warningLMarkYes()}
            sx={{ backgroundColor: "#1E355E" }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={() => warningLMarkNo()}
            sx={{ backgroundColor: "#1E355E" }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={borrowValOpen}
        onClose={onBorrowLimitExceedWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="borrow-limit-exceeded"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ backgroundColor: "#1E355E" }}
        >
          <Typography sx={{ color: "white" }}>Warning</Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="borrow-limit-exceeded">
            <div>
              <div>
                Borrow limit for {borrCptyIdModal} will exceed after this trade.
              </div>
              <div>This Trade: {thisContractVal}</div>
              <div>Borrow Limit: {borrAcctLimit}</div>
              <div>Open Borrow Contracts: {outstandingBorrow}</div>
              <div>Do you want to proceed booking this trade?</div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => onClickBorrowValYes()}
          >
            Yes
          </Button>
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => onClickBorrowValNo()}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={loanValOpen}
        onClose={onLoanLimitExceedWarningClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="loan-limit-exceed"
      >
        <DialogTitle
          sx={{ backgroundColor: "#1E355E" }}
          id="alert-dialog-title"
        >
          <Typography sx={{ color: "white" }}>Warning</Typography>
        </DialogTitle>
        <DialogContent className="mt-3">
          <DialogContentText id="loan-limit-exceed">
            <div>
              <div>
                Loan limit for {loanCptyIdModal} will exceed after this trade.
              </div>
              <div>This Trade: {thisContractVal}</div>
              <div>Loan Limit: {loanAcctLimit}</div>
              <div>Open Loan Contracts: {outstandingLoan}</div>
              <div>Do you want to proceed booking this trade?</div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-actions-dense">
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => onClickLoanValYes()}
          >
            Yes
          </Button>
          <Button
            sx={{ backgroundColor: "#1E355E" }}
            variant="contained"
            onClick={() => onClickLoanValNo()}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default SingleEntry;

